import React from 'react'

import { Formik } from 'formik'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import { Form, Button, Row, Col } from '_zari/core'
import Yup from '_zari/validation/_yup'

import * as BackgroundJobsService from 'services/backgroundJobs.service'

import * as FormGroups from './formGroups'

export const ValidationSchema = Yup.object().shape({
  mes: Yup.string().length(2).required()
})

const FormatoResumenDelMayor = () => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)
  const [cuentaContableInfo, setCuentaContableInfo] = React.useState('')

  const formInitialValues = React.useMemo(() => {
    return {
      mes: __adminContext.mesTrabajo || '',
      cuentaContableAltoBajo: ''
    }
  }, [__adminContext])

  const onSubmit = React.useCallback(
    async formData => {
      await BackgroundJobsService.iniciarReporteResumenMayor(formData)
        .then(() => {
          __zariContext.snack('info', 'Resumen del mayor enviado a procesos en background.')
        })
        .catch(({ data }) => __zariContext.snack('error', data?.error || 'No se pudo iniciar el proceso.'))
    },
    [__zariContext]
  )

  return (
    <>
      {__adminContext.mesTrabajo && (
        <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
          {({ errors, touched, isSubmitting, handleSubmit, setFieldValue, values }) => (
            <Form>
              <Row>
                <Col md={4}>
                  <FormGroups.MesContabilidadFormGroup
                    idFormato='reporteDiario'
                    iError={errors.mes}
                    iTouched={touched.mes}
                    fIsSubmitting={isSubmitting}
                  />
                  {__adminContext.flagAltoBajo && (
                    <FormGroups.CuentaContableAltoBajoFormGroup
                      setFieldValue={setFieldValue}
                      iValue={values.cuentaContableAltoBajo}
                      setCuentaInfo={setCuentaContableInfo}
                      cuentaContableInfo={cuentaContableInfo}
                    />
                  )}
                  <Row>
                    <Col md={12} className='text-right'>
                      <Button disabled={isSubmitting} onClick={handleSubmit}>
                        {isSubmitting ? 'Enviando proceso ...' : 'Generar en background'}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      )}
    </>
  )
}

export default React.memo(FormatoResumenDelMayor)
